export default "__VITE_ASSET__DEUb7Nak__"